import React from 'react';
import {
  View, Text, TouchableOpacity, StyleSheet, ScrollView,
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useToast } from 'react-native-toast-notifications';
import { useGame } from '../../context/GameContext';
import { SCREEN_NAMES } from '../../utils/constant';
import { theme } from '../Common.style';

const MEDAL_COLORS = ['#FFD700', '#C0C0C0', '#CD7F32'];
const MEDAL_EMOJIS = ['🥇', '🥈', '🥉'];

export default function GameFinalScoreScreen() {
  const navigation = useNavigation();
  const toast = useToast();
  const { room, isHost, endGame, leaveRoom, localPlayers } = useGame();

  if (!room) {
    navigation.replace(SCREEN_NAMES.GAME_LOBBY);
    return null;
  }

  const isLocal = room.mode === 'LOCAL';
  const rawPlayers = isLocal
    ? localPlayers.map((p) => ({
      name: p.name,
      score: p.score ?? 0,
    }))
    : (room.players ?? []).map((p) => ({
      name: p.user?.firstName ?? 'Joueur',
      score: p.score,
    }));

  const ranked = [...rawPlayers].sort((a, b) => b.score - a.score);

  const leave = async () => {
    if (isLocal) return;
    if (isHost) {
      await endGame();
    } else {
      await leaveRoom();
    }
  };

  const handleNewGame = async () => {
    try {
      await leave();
      navigation.replace(SCREEN_NAMES.GAME_LOBBY);
    } catch (e) {
      toast.show(e.message || 'Erreur', { type: 'danger' });
    }
  };

  const handleQuit = async () => {
    try {
      await leave();
      navigation.replace(SCREEN_NAMES.GAME_LOBBY);
    } catch {}
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>🏆 Classement final</Text>

      <ScrollView style={styles.list} contentContainerStyle={styles.listContent}>
        {ranked.map((p, i) => (
          <View key={i} style={[styles.row, i < 3 && { borderLeftWidth: 4, borderLeftColor: MEDAL_COLORS[i] ?? '#ddd' }]}>
            <Text style={styles.rank}>
              {i < 3 ? MEDAL_EMOJIS[i] : `${i + 1}.`}
            </Text>
            <Text style={styles.name}>{p.name}</Text>
            <Text style={styles.score}>{p.score} pts</Text>
          </View>
        ))}
      </ScrollView>

      <View style={styles.footer}>
        <TouchableOpacity style={styles.newGameBtn} onPress={handleNewGame}>
          <Text style={styles.newGameBtnText}>Nouvelle partie</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.quitBtn} onPress={handleQuit}>
          <Text style={styles.quitBtnText}>Quitter</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#fff' },
  title: { fontSize: 28, fontWeight: '900', textAlign: 'center', marginTop: 24, marginBottom: 16 },
  list: { flex: 1 },
  listContent: { paddingHorizontal: 20, paddingBottom: 16 },
  row: { flexDirection: 'row', alignItems: 'center', paddingVertical: 16, borderBottomWidth: 1, borderBottomColor: '#f0f0f0', paddingLeft: 12 },
  rank: { fontSize: 24, marginRight: 16, minWidth: 36 },
  name: { flex: 1, fontSize: 18, fontWeight: '600', color: '#333' },
  score: { fontSize: 20, fontWeight: '900', color: theme.colors.primary },
  footer: { padding: 20, gap: 10, borderTopWidth: 1, borderTopColor: '#eee' },
  newGameBtn: { backgroundColor: theme.colors.primary, borderRadius: 14, paddingVertical: 16, alignItems: 'center' },
  newGameBtnText: { color: '#fff', fontWeight: '700', fontSize: 17 },
  quitBtn: { backgroundColor: '#fff', borderRadius: 14, paddingVertical: 14, alignItems: 'center', borderWidth: 1.5, borderColor: '#ddd' },
  quitBtnText: { color: '#555', fontWeight: '600', fontSize: 16 },
});
